import React, { useContext } from "react";
import { IconButton } from "@fluentui/react";
import "./styles/ModalHeaderCss.css";
import themeContext from "../../context/theme/ThemeContext";
import { iconButtonStylesFunc } from "./ModalHeader";
const QCModalHeader = (props) => {
  const { getThemeColor,getAlterColor } = useContext(themeContext);
  return (
    <>
      <div
        style={{
          background:  getThemeColor("modal-header-footer"),
          borderRadius: "10px 10px 0px 0px",
          height:"50px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "none",
            justifyContent: "flex-start",
            alignItems: "center",
            paddingLeft: "15px",
            width: "35%",
          }}
        >
          {/* { props.patientName && props.patientID &&
            <>
              <span
                style={{
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#FFFFFF",
                  marginRight: "10px",
                }}
              >
                {props.patientName}
              </span>
              <span
                style={{
                  fontWeight: "400",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#BCBCBC",
                  marginLeft: "5px",
                }}
              >
                ID {props.patientID}
              </span>
            </>
          } */}
        </div>
        <div
          style={{
            fontWeight: props.isFistolugramHeader ? "700" : "400",
            fontSize: "14px",
            lineHeight: "20px",
            color: getThemeColor("primary-color"),
            display: "flex",
            justifyContent: "flex-start",
            paddingLeft:'15px',
            alignItems: "center",
            width: props.isFistolugramHeader != null && props.isFistolugramHeader != undefined ?"50%": "30%",
          }}
        >
          {props.heading}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            width: "35%",
            paddingRight: "10px",
          }}
        >
          <IconButton
            iconProps={{ iconName: "Cancel" }}
            ariaLabel="Close popup modal"
            onClick={props.handleCancel}
            styles={iconButtonStylesFunc(getThemeColor)}
            // style={{border:"none",outline:"none",color:"#FFFFFF",border:"1px solid white"}}
            className="modal-header-crossicon-button"
          />
        </div>
      </div>
    </>
  );
};

export default QCModalHeader;
